import { render, staticRenderFns } from "./pi-new-add.vue?vue&type=template&id=7fa97ec5"
import script from "./pi-new-add.vue?vue&type=script&lang=ts"
export * from "./pi-new-add.vue?vue&type=script&lang=ts"
import style0 from "./pi-new-add.vue?vue&type=style&index=0&id=7fa97ec5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports